import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getPinCodePath = () => urlHelper('/auth/pin-code');
